var fn = function( obj ){
var __t,__p='';
__p+='#ifndef MATH_INCLUDE\n#define MATH_INCLUDE 1\n\n\n#define saturate(x) clamp( x, 0.0, 1.0 )\n#define sdot( a, b ) saturate( dot(a,b) )\n\n#endif';
return __p;
};
fn.toString=fn;
module.exports = fn;